import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Grid, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import AppLoader from "../../../components/apploader";
import AuthBackButton from "../../../components/backButton";
import GlobalButton from "../../../components/button";
import AuthContainer from "../../../components/container/AuthContainer";
import InputField from "../../../components/InputField";
import Label from "../../../components/label";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { forgetPasswordUser } from "../../../services/authenticationFn";
import { encryptPassword } from "../../../utils";
import { resretPasswordValidation } from "../../../utils/validation";

const ReEnterPasswordPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(true);
  const [showReEnterPassword, setShowReEnterPassword] = useState(true);
  const [inputValues, setInputValues] = useState({
    password: "",
    confirmPassword: "",
  });
  const [inputError, setInputError] = useState({
    password: false,
    isStrongPassword: false,
    confirmPassword: false,
    isConfirmPassword: false,
  });

  useEffect(() => {
    if (!state?.params?.email || !state?.params?.code) {
      navigate("/forget-password");
    }
  }, [state]);

  const handleChangeInputs = (event) => {
    const { name, value } = event.target;
    setInputError((err) => ({
      ...err,
      [name]: false,
      isStrongPassword:
        name === "password" ? false : inputError.isStrongPassword,
      isConfirmPassword:
        name === "confirmPassword" ? false : inputError.isConfirmPassword,
    }));
    setInputValues((val) => ({ ...val, [name]: value }));
  };

  const handleResetPassword = async () => {
    try {
      const validate = resretPasswordValidation(inputValues, setInputError);
      if (validate) return;

      const payload = {
        email: state?.params?.email,
        otp: state?.params?.code,
        role: "User",
        password: encryptPassword(inputValues.password),
      };

      setIsLoading(true);
      const response = await forgetPasswordUser(payload);
      if (response.data.status === "success") {
        showSnackbar(response.data.message, "success");
        navigate("/login");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthContainer>
      <AppLoader isVisible={isLoading} />
      <AuthBackButton handleClick={() => navigate("/forget-password")} />
      <Stack textAlign={"center"}>
        <Typography variant="heading_pr">{t("newPassword")}</Typography>
        <Trans i18nKey="welcomePassReset">
          Welcome to <b style={{ color: "black" }}>Market</b> CRM, please enter
          your new password below.
        </Trans>
      </Stack>

      <Grid container rowSpacing={2} mt={3}>
        {/* New Password Field */}
        <Grid item xs={12}>
          <Label text={t("newPassword")} required htmlFor="user-new-password" />
          <InputField
            id={"user-new-password"}
            required
            type={showNewPassword ? "password" : "text"}
            placeholder={t("enterNewPass")}
            InputEndIcon={
              showNewPassword ? (
                <VisibilityOffIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setShowNewPassword(false)}
                />
              ) : (
                <VisibilityIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setShowNewPassword(true)}
                />
              )
            }
            inputError={inputError.password || inputError.isStrongPassword}
            helperText={
              inputError.password
                ? t("passwordRequired")
                : inputError.isStrongPassword
                ? t("passwordValidationDesc")
                : null
            }
            name={"password"}
            value={inputValues.password}
            onChange={handleChangeInputs}
          />
        </Grid>

        {/* Re-Enter Password Field */}
        <Grid item xs={12}>
          <Label text={t("reEnter")} required htmlFor="user-reenter-password" />
          <InputField
            id={"user-reenter-password"}
            required
            placeholder={`${t("reEnter")} ${t("newPassword")}`}
            type={showReEnterPassword ? "password" : "text"}
            InputEndIcon={
              showReEnterPassword ? (
                <VisibilityOffIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setShowReEnterPassword(false)}
                />
              ) : (
                <VisibilityIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setShowReEnterPassword(true)}
                />
              )
            }
            inputError={
              inputError.confirmPassword || inputError.isConfirmPassword
            }
            helperText={
              inputError.confirmPassword
                ? t("reEnterPassword")
                : inputError.isConfirmPassword
                ? t("passwordNotMatch")
                : null
            }
            name={"confirmPassword"}
            value={inputValues.confirmPassword}
            onChange={handleChangeInputs}
          />
        </Grid>
      </Grid>

      <GlobalButton
        btnText={"updatePassword"}
        handleClickBtn={handleResetPassword}
        styleProps={{
          width: "100%",
          height: 50,
          mt: 6,
          fontSize: "1.125rem",
        }}
      />
    </AuthContainer>
  );
};

export default ReEnterPasswordPage;
